import { ENTITY } from 'modules/campaigns/config';
import { addIndication, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { fetchBulkCampaignsSuccess } from '../../../actions';
import { fromGWtransformers } from '../../../flows/flowsUtils';

const indication = {
    message: (
        <FormattedMessage
            id="entity.editor.fetch.campaigns.error"
            defaultMessage="Something went wrong when we tried to fetch the requested campaigns."
        />
    ),
    type: INDICATION_TYPES.ERROR,
    highlight: <FormattedMessage id="error.highlight" />,
};

export const fetchCampaignsForEdit =
    (accountId, selectedCampaignIds, bulkOperationsApi, { hideError } = {}) =>
    async dispatch => {
        try {
            const { results } = await bulkOperationsApi.getBulkAccountCampaigns({ accountId, selectedCampaignIds });
            const campaigns = results?.map(campaign => fromGWtransformers[ENTITY.CAMPAIGN](campaign));

            dispatch(fetchBulkCampaignsSuccess(campaigns));

            return campaigns;
        } catch {
            if (!hideError) {
                dispatch(addIndication(indication));
            }
            return null;
        }
    };
